export default __webpack_public_path__ + "static/media/windows.2fd116b6.svg";